import { useEffect, useState } from "react";

const useCategoryData = (categoryId, subcategoryId) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        let url;
        // If "Tous" is selected, fetch aggregated data
        if (categoryId === "tous") {
          url = `/data/all.json`;
        } else {
          // Construct the URL dynamically based on category and subcategory
          url = `/data/${categoryId}`;
          if (subcategoryId) {
            url += `/${subcategoryId}.json`;
          } else {
            url += `.json`; // Fetch category images without subcategory
          }
        }

        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to fetch data for ${subcategoryId || categoryId}`);
        }
        const result = await response.json();
        setData(result);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    if (categoryId) {
      fetchData();
    }
  }, [categoryId, subcategoryId]);

  return { data, loading, error };
};

export default useCategoryData;
